export class LocalizationInfo {

    private element: HTMLElement;

    constructor() {
        this.element = document.querySelector('.c-localization-info');

        if  (this.element) {
            this.initCloseButton();
        }
    }

    initCloseButton() {
        this.element.querySelector('.c-localization-info__close').addEventListener('click', function () {
            // @ts-ignore Cookies is set globally
            Cookies.set('bd_routing', 'closed');
        });
    }

}

new LocalizationInfo();